"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const InvalidComponentError_1 = __importDefault(require("../ErrorComponent/InvalidComponentError"));
const Spinner_1 = require("../Spinner/Spinner");
const Button_module_css_1 = __importDefault(require("../public/Button.module.css"));
const Button = react_1.default.forwardRef((props, ref) => {
    const { variant = "primary", size = "normal", isBold = true, isDisabled = false, isLoading = false, iconColor = "#000000", iconSize = "1x", text, onClick, className, icon, dataCy, id, style, testid, children } = props, rest = __rest(props, ["variant", "size", "isBold", "isDisabled", "isLoading", "iconColor", "iconSize", "text", "onClick", "className", "icon", "dataCy", "id", "style", "testid", "children"]);
    if ((!icon && !text && react_1.default.Children.count(children) == 0) && !isLoading) {
        throw new InvalidComponentError_1.default("Buttons must contain any combination of the following props: (icon, text, children)");
    }
    let variantClass = "";
    if (variant === "primary") {
        if (isLoading) {
            variantClass = Button_module_css_1.default.primaryBtnSpinner;
        }
        else {
            variantClass = Button_module_css_1.default.primaryBtn;
        }
    }
    else if (variant === "secondary") {
        if (isLoading) {
            variantClass = Button_module_css_1.default.secondaryBtnSpinner;
        }
        else {
            variantClass = Button_module_css_1.default.secondaryBtn;
        }
    }
    else if (variant === "cancel") {
        if (isLoading) {
            variantClass = Button_module_css_1.default.cancelBtnSpinner;
        }
        else {
            variantClass = Button_module_css_1.default.cancelBtn;
        }
    }
    else if (variant === "success") {
        if (isLoading) {
            variantClass = Button_module_css_1.default.successBtnSpinner;
        }
        else {
            variantClass = Button_module_css_1.default.successBtn;
        }
    }
    const styles = Object.assign({ fontFamily: isBold ? "Geomanist-Bold" : "Geomanist", fontSize: size === "normal" ? "16px" : "13px", minWidth: size === "normal" ? "136px" : "0px", padding: "11px 14px", borderRadius: "4px" }, style);
    let btnClasses = `btn shadow-none ${Button_module_css_1.default.nsBtn} ${className} ${variantClass}`;
    return (react_1.default.createElement("button", Object.assign({ className: btnClasses, style: styles, onClick: !isDisabled ? onClick : undefined, "data-cy": dataCy, "data-testid": testid, disabled: isDisabled, id: id, ref: ref }, rest),
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-center" }, isLoading ?
            (variant === "primary" ?
                react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-center", style: { mixBlendMode: "luminosity", width: (size === "normal" ? "16px" : "13px"), height: (size === "normal" ? "16px" : "13px") } },
                    react_1.default.createElement(Spinner_1.Spinner, { size: size === "normal" ? 16 : 13 }))
                :
                    react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-center", style: { width: (size === "normal" ? "16px" : "13px"), height: (size === "normal" ? "16px" : "13px") } },
                        react_1.default.createElement(Spinner_1.Spinner, { size: size === "normal" ? 16 : 13 })))
            :
                react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.count(children) > 0 ?
                    react_1.default.createElement(react_1.default.Fragment, null, children)
                    :
                        react_1.default.createElement(react_1.default.Fragment, null,
                            icon ?
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, color: iconColor, size: iconSize })
                                :
                                    react_1.default.createElement(react_1.default.Fragment, null),
                            text ?
                                react_1.default.createElement("span", { style: { marginLeft: `${icon ? "1em" : "inherit"}`, lineHeight: `${size === "normal" ? "16" : "13"}px` } }, text)
                                :
                                    react_1.default.createElement(react_1.default.Fragment, null))))));
});
exports.default = Button;
